'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var _ = require('lodash');
var compose = require('../hoc/compose');
var textInput = require('./textInput');
var displayNames = require('./displayNames');

var UP = 38;
var DOWN = 40;
var isValid = function isValid(value) {
    return (/^-?\d*\.?\d*$/.test(value)
    );
};

var NumericInput = function (_React$Component) {
    _inherits(NumericInput, _React$Component);

    function NumericInput(props) {
        _classCallCheck(this, NumericInput);

        var _this = _possibleConstructorReturn(this, (NumericInput.__proto__ || Object.getPrototypeOf(NumericInput)).call(this, props));

        _this.getValid = function (rawValue) {
            var value = isNaN(rawValue) ? 0 : Number(rawValue);
            if (value < _this.props.min) {
                return String(_this.props.min);
            }
            if (_this.props.max < value) {
                return String(_this.props.max);
            }
            return String(value);
        };
        _this.state = {
            rawValue: _this.getValid(props.value),
            showTooltip: false
        };

        _this.handleChange = function (rawValue) {
            var value = Number(rawValue);
            var shouldChange = !isNaN(value) && _this.props.min <= value && value <= _this.props.max;
            var callback = shouldChange ? _.partial(_this.props.onChange, value) : _.noop;

            if (isValid(rawValue)) {
                _this.setState({ rawValue: rawValue, showTooltip: false }, callback);
            } else {
                _this.setState({ showTooltip: true });
            }
        };

        _this.handleBlur = function (e, isCanceled) {
            var onChangeCallback = _.noop;
            var value = Number(_this.state.rawValue);
            if (value < _this.props.min) {
                onChangeCallback = _.partial(_this.props.onChange, _this.props.min);
            } else if (_this.props.max < value) {
                onChangeCallback = _.partial(_this.props.onChange, _this.props.max);
            }

            var callback = function callback() {
                _this.props.onBlur(e, isCanceled);
                onChangeCallback();
            };
            var validValue = _this.getValid(_this.state.rawValue);
            _this.setState({ rawValue: validValue, showTooltip: false }, callback);
        };

        _this.handleKeyDown = function (_ref) {
            var keyCode = _ref.keyCode;

            if (keyCode === UP) {
                _this.handleChange(String(Number(_this.state.rawValue) + _this.props.step));
            } else if (keyCode === DOWN) {
                _this.handleChange(String(Number(_this.state.rawValue) - _this.props.step));
            }
        };

        _this.getTooltipProps = function () {
            return {
                isOpen: _this.state.showTooltip,
                content: _this.props.numbersOnlyMessage,
                openOnMouseEnter: false,
                closeOnMouseLeave: false,
                shouldTranslate: _this.props.shouldTranslate,
                onScroll: function onScroll() {
                    _this.setState({ showTooltip: false });
                }
            };
        };
        return _this;
    }

    _createClass(NumericInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                this.setState({ rawValue: this.getValid(nextProps.value) });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(textInput, _.assign({}, this.props, {
                showInfoTooltip: !_.isEmpty(this.props.numbersOnlyMessage),
                infoTooltipProps: this.getTooltipProps(),
                className: 'control-numeric-input' + (this.state.showTooltip ? ' invalid' : ''),
                value: this.state.rawValue,
                onChange: this.handleChange,
                onBlur: this.handleBlur,
                onKeyDown: this.handleKeyDown,
                shouldTranslate: false
            }));
        }
    }]);

    return NumericInput;
}(React.Component);

NumericInput.displayName = displayNames.NUMERIC_INPUT;
NumericInput.propTypes = {
    value: React.PropTypes.number,
    onChange: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    prefix: React.PropTypes.string,
    innerInputClass: React.PropTypes.string,
    onFocus: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    focus: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    focusOnPrefixClick: React.PropTypes.bool,
    min: React.PropTypes.number,
    max: React.PropTypes.number,
    step: React.PropTypes.number,
    numbersOnlyMessage: React.PropTypes.string
};
NumericInput.defaultProps = {
    onChange: _.noop,
    onBlur: _.noop,
    focusOnPrefixClick: true,
    min: 0,
    max: 100,
    step: 1
};

module.exports = compose(NumericInput);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/numericInput.js